import Pako from "pako";

const gzipString = (str: string) => {
  return Pako.gzip(str);
};

const gzipToBase64 = (u8A: Uint8Array) => {
  return btoa(String.fromCharCode(...new Uint8Array(u8A)));
};

const compressString = (str: string) => {
  const gzipped = gzipString(str);
  const base64 = gzipToBase64(gzipped);

  return base64;
};

const gzipFromBase64 = (base64: string) => {
  return Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
};

const decompressString = (base64: string) => {
  const u8A = gzipFromBase64(base64);
  const decompressed = Pako.ungzip(u8A, { to: "string" });

  return decompressed;
};

export { compressString, decompressString };
